import { DateTime, Duration } from "luxon";
import { DayOfWeek, dayOfWeekLabels } from "./models/DayOfWeek";
import { isoFormats } from "./models/isoFormats";

const now = (args: { timezone: string }): DateTime => {
  return DateTime.local().setZone(args.timezone);
};

const fromIsoDate = (args: { isoDate: string; timezone: string }): DateTime => {
  return DateTime.fromISO(args.isoDate, { zone: args.timezone });
};

const fromIsoDateTimeUtc = (args: { isoDateTimeUtc: string; timezone: string }): DateTime => {
  return DateTime.fromISO(args.isoDateTimeUtc, { zone: args.timezone });
};

const fromIsoDateAndTimeOfDay = (args: { isoDate: string; timeOfDay: string; timezone: string }): DateTime => {
  const { timeOfDay, isoDate, timezone } = args;
  const timeOfDay24Hours = DateTime.fromFormat(timeOfDay, isoFormats.TIME_OF_DAY).toFormat(
    isoFormats.TIME_OF_DAY_24_HOURS
  );
  const isoDateTime = `${isoDate}T${timeOfDay24Hours}`;
  return DateTime.fromISO(isoDateTime, { zone: timezone });
};

const fromJsDate = (args: { jsDate: Date; timezone: string }) => {
  const { jsDate, timezone } = args;
  return DateTime.fromJSDate(jsDate, { zone: timezone });
};

const fromDuration = (args: { duration: string; timezone: string }): DateTime => {
  const { duration } = args;
  const dateTimeNow = getDateTime.now(args);
  const currentDuration = Duration.fromISO(duration);
  return dateTimeNow.plus(currentDuration);
};

const fromTimeOfDay = (args: { timeOfDay: string; timezone: string }): DateTime => {
  return DateTime.fromFormat(args.timeOfDay, isoFormats.TIME_OF_DAY, { zone: args.timezone });
};

const fromDayOfWeek = (args: { dayOfWeek: DayOfWeek; timezone: string }): DateTime => {
  return DateTime.fromFormat(args.dayOfWeek, "cccc", { zone: args.timezone });
};

const fromDayOfWeekAndTimeOfDay = (args: { dayOfWeek: DayOfWeek; timeOfDay: string; timezone: string }): DateTime => {
  const { dayOfWeek, timeOfDay, timezone } = args;
  return DateTime.fromFormat(`${dayOfWeekLabels[dayOfWeek]} ${timeOfDay}`, "cccc h:mm a", { zone: timezone });
};

export const getDateTime = {
  now,
  fromIsoDate,
  fromIsoDateTimeUtc,
  fromIsoDateAndTimeOfDay,
  fromJsDate,
  fromDuration,
  fromTimeOfDay,
  fromDayOfWeek,
  fromDayOfWeekAndTimeOfDay,
};
